import styled from 'styled-components';
import { Container } from '@material-ui/core';
import { InformationName } from '../CampaignDetails/CampaignDetails.styles';

export const StyledContainer = styled(Container)`
    && {
        width: 620px;
        padding: 0;
        @media screen and (max-width: 690px) {
            width: 100%;
            padding: 0 16px;
        }
    }
`;

export const StyledInformationName = styled(InformationName)`
    margin: ${({ theme }) => theme.spacing * 6}px 0 ${({ theme }) => theme.spacing * 2}px;
`;

export const ImageWrapper = styled.div`
    width: 620px;
    height: 350px;
    position: relative;
    @media screen and (max-width: 690px) {
        width: 100%;
    }
`;

export const Image = styled.div`
    background-color: green;
    width: 100%;
    height: 100%;
    border-radius: 6px;
`;

export const ImageOptions = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 60px;
    background-color: rgba(0,0,0,0.7);
    border-radius: 0 0 6px 6px;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1000;
    box-sizing: border-box;
    padding: ${({ theme }) => theme.spacing * 6}px;
    > p {
        margin: 0 0 0 ${({ theme }) => theme.spacing * 10}px;
        color: white;
        font-size: 12px;
        font-weight: bold;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        cursor: pointer;
        > svg {
            margin-right: ${({ theme }) => theme.spacing * 2}px;
            width: 20px;
            height: auto;
        }
    }
`;

export const FlexWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: ${({ theme }) => theme.spacing * 10}px;
    > p {
        font-size: 12px;
        line-height: 24px;
        font-weight: bold;
        color: ${({ theme }) => theme.colors.gray};
        margin: 0;
        cursor: pointer;
    }
`;

export const Button = styled.button`
    background-color: ${({ theme }) => theme.colors.primary};
    width: 220px;
    height: 44px;
    line-height: 44px;
    cursor: pointer;
    text-align: center;
    border-radius: 6px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.white};
    text-transform: uppercase;
    font-size: 12px;
    margin-left: ${({ theme }) => theme.spacing * 10}px;
    outline: none;
    border: none;
`;

export const CharactersInfo = styled.p`
    color: ${({ theme }) => theme.colors.blue};
    font-size: 12px;
    line-height: 24px;
    opacity: .87;
    text-align: right;
    margin: 0;
`;

export const CancelButton = styled(Button)`
    background-color: unset;
    color: ${({ theme}) => theme.colors.gray};
    width: 50px;
`;
